/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentSearchResponseDto } from '../../models/content-search-response-dto';

export interface UserContentControllerSearch$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 1차 카테고리
 */
  firstCategoryId?: string;

/**
 * 2차 카테고리
 */
  secondCategoryId?: string;

/**
 * 노출된 콘텐츠만 가져오기 여부
 */
  active?: boolean;
}

export function userContentControllerSearch(http: HttpClient, rootUrl: string, params: UserContentControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentSearchResponseDto>> {
  const rb = new RequestBuilder(rootUrl, userContentControllerSearch.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('firstCategoryId', params.firstCategoryId, {});
    rb.query('secondCategoryId', params.secondCategoryId, {});
    rb.query('active', params.active, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentSearchResponseDto>;
    })
  );
}

userContentControllerSearch.PATH = '/api/content/user/search';
